export type MfePropsType = {
  properties?: ExternalOptionsType;
  [key: string]: unknown;
};

// Defines how the MFE was launched and how it will close
export enum InitializationMethod {
  Navigation = 'Navigation',
  JWebServiceRouting = 'JWebServiceRouting',
  JShellServiceRouting = 'JShellServiceRouting',
  Modal = 'Modal'
}

export enum TenantSelectionStrategy {
  // Shows the tenant selector as usual
  ShowTenantSelector = 'SHOW_TENANT_SELECTOR',
  // Auto selects the last tenant used by this user
  UseLastTenant = 'USE_LAST_TENANT',
  /**
   * @deprecated This feature is deprecated and will be removed in a future version.
   * The removal of tenantType from the API will make this feature non-functional.
   * Please use ShowTenantSelector or UseLastTenant strategies instead.
   *
   * Picks the first tenant on the tenant list, based on the TenantSelectionStrategyRule
   */
  PickFirstUsingRules = 'PICK_FIRST_USING_RULES'
}

/**
 * @deprecated This type is deprecated and will be removed in a future version.
 * The removal of tenantType from the API will make this feature non-functional.
 * This type is only used with the deprecated PickFirstUsingRules strategy.
 */
export type TenantSelectionStrategyRule = {
  // Field equal to the TenantDataType.type
  type: string;
};

export type LocalizationPropertiesType = {
  country: string;
  language: string;
};

// Properties that come from external sources (query parameters, manifest, or service routing)
export type ExternalOptionsType = {
  /**
   * @deprecated This property is deprecated and will be removed in a future version.
   * The removal of the User Onboarding makes this property non-functional.
   */
  isDemo: boolean;
  accountLandingPage: string;
  errorMfeAssetReference?: string;
  localization?: LocalizationPropertiesType;
  propositionScreen?: string;
  from?: InitializationMethod;
  // Defines the tenant selection strategy to used
  tenantSelectionStrategy?: TenantSelectionStrategy;
  /**
   * @deprecated This property is deprecated and will be removed in a future version.
   * The removal of tenantType from the API will make this feature non-functional.
   * Only used with the deprecated PickFirstUsingRules strategy.
   *
   * If TenantSelectionStrategy is set to PickFirstUsingRules, this should be the rules used to select the tenant
   */
  tenantSelectionStrategyRules?: TenantSelectionStrategyRule[];
  // Forces user re-authentication regardless of current login status
  forceLogin?: boolean;
};

// Internal options built within the code for logic purposes
export interface InternalOptionsType {
  initializationMethod?: InitializationMethod;
}

export type MfeOptionsType = ExternalOptionsType & InternalOptionsType;
